// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"365fe5f0","488":"744458da","767":"469d2065"}[chunkId] + ".chunk.js";
};